import * as ko from 'knockout';
import { app } from '../app';
import { Deferred } from '../utils/deferred';
import i18n from '../i18n';
import { STATE_CHANGE_REASON_MAX_LENGTH } from '../models/TrialState';

class StateChangeReasonDialog {
  reason = ko.observable('');
  maxLength = STATE_CHANGE_REASON_MAX_LENGTH;
  prompt: string;
  label: string;

  isSaveButtonDisabled = ko.computed(() => {
    return this.reason().trim() === '';
  });

  result: Deferred<string>;

  constructor(params: { result: Deferred<string>; prompt: string; label: string }) {
    this.result = params.result;
    this.prompt = params.prompt;
    this.label = params.label;
  }

  close = () => {
    this.result.reject();
  };

  save = () => {
    if (this.isSaveButtonDisabled()) {
      return;
    }

    this.result.resolve(this.reason().trim());
  };
}
const template = require('raw-loader!../../templates/components/state_change_reason_dialog.html').default;
const name = 'state-change-reason-dialog';

ko.components.register(name, {
  viewModel: StateChangeReasonDialog,
  template,
});

interface ReasonPromptCopy {
  prompt: string;
  label: string;
}

export function openStateChangeReasonDialog(copy?: ReasonPromptCopy): Promise<string> {
  return app.formsStackController.push({
    name,
    className: 'state-change-reason-dialog',
    title: i18n.t('Reason required')(),
    params: {
      result: new Deferred<string>(),
      prompt: copy?.prompt ?? i18n.t('You must provide a reason for changing the trial state.')(),
      label: copy?.label ?? i18n.t('Reason for the state change')(),
    },
  });
}
